<h2 mat-dialog-title *ngIf="selectionIndex==0" translate>Color Legend</h2>
<h2 mat-dialog-title *ngIf="!isStandardView" translate>{{dialogTitle}}</h2>
<div mat-dialog-title *ngIf="isStandardView && isTermSelected" style="margin-bottom: 0px;" translate>
  Term Details -{{longDescription}}
</div>
<div mat-dialog-title *ngIf="isStandardView && isTermSelected" style="margin-bottom: 0px;">
  {{selectedCourse.Course}} - {{selectedCourse.TeacherName}}
</div>

<mat-dialog-content>
  <div>
    <table *ngIf="!isTermSelected">
      <tr>
        <td class="divCellHeading" translate>Course Name</td>
        <td class="divCellContent">{{course}}</td>
      </tr>
      <tr>
        <td class="divCellHeading" translate>Course-Section</td>
        <td class="divCellContent">{{subjectSection}}</td>
      </tr>
      <tr>
        <td class="divCellHeading" translate>School</td>
        <td class="divCellContent">{{school}}</td>
      </tr>
      <tr>
        <td class="divCellHeading" translate>Grading Period</td>
        <td class="divCellContent">{{gradingTerm}}</td>
      </tr>
      <tr *ngIf="showStandard()">
        <td class="divCellHeading" translate>Standard</td>
        <td class="divCellContent">{{standard}}</td>
      </tr>
      <tr>
        <td class="divCellHeading" translate>Grade</td>
        <td class="divCellContent">
          {{grade}}&nbsp;&nbsp;
          <a class="link" (click)="viewAssignment()"
            *ngIf="isStandardView == false && (isGradeBookGrade == true || (gradingTermDescription != null && gradingTermDescription.length > 0))"
            translate>Assignments</a>
        </td>
      </tr>
      <tr *ngIf="gradeScale.length > 0 && isStandardView==true && isTermSelected==false">
        <td class="divCellHeading" style="vertical-align:top;padding-top:20px;" translate>Grading Scale</td>
        <td class="divCellContent" style="padding-top:20px;">
          <div>
            <table>
              <tr *ngFor="let GS of gradeScale">
                <td>{{GS}}</td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
    </table>
    <div style="display:block;" *ngIf="comment.length != 0">
      <div style="padding-top :5px;">
        <div style="color: #595959;" translate>Comment</div>
        <div>{{comment}}</div>
      </div>
    </div>
    <div *ngIf=selectedView()>
      <div *ngIf="citizenship.length != 0 && LoginSettings.ParentPortalReportCardGradesShowCitizenship">
        <div style="color: #595959; padding-top: 10px;padding-bottom:5px;">
          {{citizenshipLabel}}
        </div>
        <div style="width: 100%; background-color: #F0F0F0;">
          <div class="divCellContent" style="min-width: 200px; line-height: 40px; padding-left: 5px;">{{citizenship}}
          </div>
        </div>
      </div>
      <div style="color: #595959; padding-top: 10px;" *ngIf="workhabits.length != 0" translate>
        {{behaviorLabel}}
      </div>
      <div *ngIf="workhabits.length > 0" style="width:100%;">
        <table style="width:100%;"class="table">
          <tbody *ngFor="let habits of behaviorSkills">
            <tr>
              <td class="divCellContent" style="width:100%;padding-left:5px;">{{habits}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="flex-footer-left">
      <tyl-button style="float: left;" image="next arrow.png" label="Continue to Assignments"
      (clickEvent)="viewAssignment()"
      *ngIf="(isStandardView == false || isTermSelected==true) && (isGradeBookGrade == true || (gradingTermDescription != null && gradingTermDescription.length > 0))">
    </tyl-button>
  </div>
  <div class='flex-footer-right'>
    <tyl-button style="float:right" image="Cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
</div>
</mat-dialog-actions>
